// customer-master.component.ts
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AlertService } from 'src/app/_services/alert.service';
import { MenusService } from 'src/app/_services/menu.service';
import { StorageService } from 'src/app/_services/storage.service';
import { PiiGridService } from 'src/app/_services/pii-grid.service';
import { SideNavService } from 'src/app/views/layout/sidebar/side-name.service';
import { SidebarComponent } from 'src/app/views/layout/sidebar/sidebar.component';
import { environment } from 'src/environments/environment';
import { MerchantService } from '../../merchants/merchant-master/merchant.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import {
  ColDef, Column, ColumnApi, FilterChangedEvent, FilterModifiedEvent,
  FilterOpenedEvent, GridApi, GridOptions, GridReadyEvent,
  PaginationChangedEvent, RowClickedEvent
} from 'ag-grid-community';
import { BtnCellRenderer } from 'src/app/common/button-cell-renderer.component';
import { BtnCellRenderer1 } from 'src/app/common/button-cell-renderer.component1';
import { FormControl, FormGroup } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { NgbDateStruct, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from '../customer-service';
import { UserService } from 'src/app/_services/user.service';
import { DocumentsCellRendererComponent } from 'src/app/common/documents-cell-renderer.component';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

// ✅ Export must exclude UI action columns
const EXCLUDED_EXPORT_FIELDS = new Set<string>(['actions', 'screen', 'unmasking']);

export interface CustomerListFilter {
  columns?: any;
  fullname?: string;
  mobile?: string;
  startDate?: string;
  endDate?: string;
  pageRecords?: number;
  pageNumber?: number;
  emailId?: string;
  Status?: string;
  KycStatus?: string;
}

export interface IMerchantData {
  name: string;
  merchantId: string;
  businessName: string;
  contactperson: string;
  id: number;
  contactno: string;
  emailid: string;
  state: string;
  city: string;
  isdeleted: string;
}

const { defaultPageSizeArr, defaultPageSize } = environment;

@Component({
  selector: 'app-customer-master',
  templateUrl: './customer-master.component.html',
  styleUrls: ['./customer-master.component.scss']
})
export class CustomerMasterComponent implements OnInit {

  @Output() merchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() merchantConfigEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() BlockedmerchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() ScreeningReportEvent: EventEmitter<any> = new EventEmitter<any>();

  public quickFilterShow: boolean = false;
  public pageSize: number = defaultPageSize;
  public pageSizeArr: any = defaultPageSizeArr;

  public fullName: string = '';
  public mobileNumber: string = '';
  public kycStatus: string = '';
  public status: string = '';
  public searchFromDate!: NgbDateStruct;
  public searchToDate!: NgbDateStruct;
  public selectedMerchant: string = '';
  public emailId: string = '';
  public walletId: string = '';
  public documentId: string = '';

  totalRecords: any;
  merchantStatus: any;

  modalConfigBlocked!: ModalConfig;
  modalConfigReport!: ModalConfig;
  modalConfigAdd!: ModalConfig;
  modalConfigEdit!: ModalConfig;
  modalConfigMerchant!: ModalConfig;

  user_type: 'NULL' = 'NULL';
  tableInfo: any;

  maxSize!: number;
  ellipses: boolean = true;

  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;

  public rowData!: IMerchantData[];

  collectiondata: any;
  collectionSize: number = 0;
  currentPage: number = 1;

  public permissions: any = '';
  Resultdata: any;
  merchantStatusdata: any;

  currentDate: any = new Date();
  private filterObj: any = {};
  globalSearch: string = '';
  private innerWidth!: number;

  image: any;
  mindatadis: boolean = true;
  loading: boolean = false;

  orvreport!: FormGroup;
  actionPermission: any;
  public gridOptions!: GridOptions;

  public pageNumber: number = 0;
  minDate!: NgbDateStruct;
  maxDate!: NgbDateStruct;
  maxDateFrom!: NgbDateStruct;

  // Column selector search input
  public columnSearchText: string = '';

  // per-user localStorage key
  private profileEmailForKey: string = '';
  private storageReady: boolean = false;

  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 170,
    resizable: true,
    sortable: false,
    filter: false,
    autoHeight: true
  };

  @ViewChild('modalReportCustomer') private modalReportComponent!: ModalComponent;
  @ViewChild('modalblokedCustomer') private modalblockedComponent!: ModalComponent;
  @ViewChild('filSearchMerName') private filSearchMerName!: NgSelectComponent;
  @ViewChild('filSearchMID') private filSearchMID!: NgSelectComponent;
  @ViewChild('filResellerPartnerId') private filResellerPartnerId!: NgSelectComponent;
  @ViewChild('filStatus') private filStatus!: NgSelectComponent;
  @ViewChild('filSearchToDate') private filSearchToDate!: FormControl;
  @ViewChild('filSearchFromDate') private filSearchFromDate!: FormControl;

  // ---------------------------
  // Column definitions
  // ---------------------------
  public columnDefs: ColDef[] = [
    { field: 'fullName', headerName: 'Fullname', lockVisible: true, resizable: true, cellRenderer: 'agGroupCellRenderer' },
    { field: 'userId', headerName: 'Customer ID', sortable: true, filter: true },
    { field: 'walletId', headerName: 'Wallet ID', sortable: true, filter: true },
    { field: 'walletType', headerName: 'Customer Wallet Level', sortable: true, filter: true },
    { field: 'mobileNumber', headerName: 'Contact No', lockVisible: true },
    {
      field: 'documents', headerName: 'Documents', lockVisible: true,
      cellRenderer: DocumentsCellRendererComponent, cellRendererParams: { userType: 'CUSTOMER', enableStatusUpdates: true },
      minWidth: 270, autoHeight: true
    },

    { field: 'documentType', headerName: 'Document Type', sortable: true, filter: true },
    { field: 'governmentId', headerName: 'Document ID', sortable: true, filter: true },
    { field: 'expiryDate', headerName: 'Document Expiry Date', sortable: true, filter: true },
    { field: 'nationality', headerName: 'Nationality', lockVisible: true },
    { field: 'screeningId', headerName: 'Screening ID', lockVisible: true },
    { field: 'screeningProviderCode', headerName: 'Screening Provider Code', lockVisible: true },

    { field: 'createdOn', headerName: 'Created On', lockVisible: true },
    { field: 'walletStatus', headerName: 'Wallet Status', lockVisible: true },
    { field: 'kycStatus', headerName: 'KYC Status', lockVisible: true },
    { field: 'finalStatus', headerName: 'Final Status', lockVisible: true },
    { field: 'screeningId', headerName: 'Screening ID', lockVisible: true },
    { field: 'screeningProviderCode', headerName: 'Screening Provider Code', lockVisible: true },
    { field: 'faceMatchStatus', headerName: 'Face Match Status', lockVisible: true },
    { field: 'currentTrack', headerName: 'Current Track', lockVisible: true },
    { field: 'remark', headerName: 'Remarks', lockVisible: true },

    {
      field: 'actions', headerName: 'Actions', lockVisible: true, width: 120,
      cellRenderer: BtnCellRenderer1,
      cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            this.tableInfo = param.data.userId;
            const mobile = this.tableInfo;
            const walletStatus = param.data.walletStatus;

            this.BlockedmerchantSelectEvent.emit({ mobile, walletStatus });
            return await this.modalblockedComponent.open();
          },
          buttonIconClass: 'icon-settings',
          buttonVisible: true
        }
      ]
    },

    {
      field: 'screen', headerName: 'Screening Report', lockVisible: true, width: 180,
      cellRenderer: BtnCellRenderer,
      cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            this.tableInfo = param.data.id || param.data.mobileNumber;
            this.customerService.getCustomerPdfById(this.tableInfo)
              .subscribe((data: any) => {
                const reader = new FileReader();
                reader.readAsDataURL(data.body);
                new Promise((resolve) => {
                  reader.onloadend = function () { resolve(reader.result); };
                }).then((res) => {
                  this.image = res;
                  this.ScreeningReportEvent.emit(res);
                  return this.modalReportComponent.open();
                });
              });
          },
          buttonIconClass: 'icon-eye'
        },
        {
          clicked: async (event: any, param: any) => {
            this.tableInfo = param.data.id || param.data.mobileNumber;
            this.customerService.getCustomerPdfById(this.tableInfo)
              .subscribe((data: any) => {
                const reader = new FileReader();
                reader.readAsDataURL(data.body);
                new Promise((resolve) => {
                  reader.onloadend = function () { resolve(reader.result); };
                }).then((res) => {
                  this.image = res;
                  this.downloadPdf(res, param.data.fullName);
                });
              });
          },
          buttonIconClass: 'icon-arrow-down'
        }
      ]
    },

    {
      field: 'unmasking', headerName: 'Unmasking', lockVisible: true, width: 120,
      cellRenderer: BtnCellRenderer1,
      cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            this.piiGridService.unmaskRow(param.data, this.gridApi);
          },
          buttonIconClass: 'icon-frame-1',
          buttonText: '',
          buttonVisible: true,
          customImage: 'assets/images/unmask-icon.png'
        }
      ]
    }
  ];

  // used by dropdown
  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];

  // columns shown in grid
  tableSelectedColumn: ColDef[] = [];

  constructor(
    private menuService: MenusService,
    private location: Location,
    private alertService: AlertService,
    private sideNavService: SideNavService,
    private merchantService: MerchantService,
    private router: Router,
    private sidebarComponent: SidebarComponent,
    private storageService: StorageService,
    private ngbCalender: NgbCalendar,
    private ngbDateParserFormatter: NgbDateParserFormatter,
    private customerService: CustomerService,
    private userService: UserService,
    private piiGridService: PiiGridService
  ) {
    this.maxDateFrom = this.ngbCalender.getToday();
    this.maxDate = this.ngbCalender.getToday();
    this.merchantService.getBusinessType().subscribe((data) => this.merchantStatus = data);

    // ✅ default select all
    this.tableSelectedColumn = [...this.columnDefsCopy];
    this.ensureActionsAlwaysSelected();
  }

  // ---------------------------
  // Column dropdown helpers
  // ---------------------------
  get filteredColumns(): ColDef[] {
    const q = (this.columnSearchText || '').trim().toLowerCase();
    if (!q) return this.columnDefsCopy;

    return this.columnDefsCopy.filter(c => {
      const label = (c.headerName || c.field || '').toString().toLowerCase();
      return label.includes(q);
    });
  }

  private getColumnsStorageKey(): string {
    const email = (this.profileEmailForKey || '').trim().toLowerCase();
    return `customerMaster.columns.${email || 'anonymous'}`;
  }

  private persistColumnSelection(): void {
    if (!this.storageReady) return; // ✅ don’t save using "anonymous" key by mistake
    try {
      const selectedFields = (this.tableSelectedColumn || [])
        .map(c => c.field)
        .filter(Boolean) as string[];

      if (!selectedFields.includes('actions')) selectedFields.push('actions');

      localStorage.setItem(this.getColumnsStorageKey(), JSON.stringify(selectedFields));
    } catch { }
  }

  private loadColumnSelectionFromStorage(): boolean {
    try {
      const raw = localStorage.getItem(this.getColumnsStorageKey());
      if (!raw) return false;

      const fields = JSON.parse(raw) as string[];
      if (!Array.isArray(fields) || fields.length === 0) return false;

      const selectedSet = new Set(fields);
      selectedSet.add('actions');

      this.tableSelectedColumn = this.columnDefsCopy.filter(c => !!c.field && selectedSet.has(c.field));
      if (!this.tableSelectedColumn.length) this.tableSelectedColumn = [...this.columnDefsCopy];

      this.ensureActionsAlwaysSelected();
      return true;
    } catch {
      return false;
    }
  }

  private ensureActionsAlwaysSelected(): void {
    const hasActions = this.tableSelectedColumn?.some(c => c.field === 'actions');
    const actionsCol = this.columnDefsCopy.find(c => c.field === 'actions');
    if (!hasActions && actionsCol) {
      const set = new Set((this.tableSelectedColumn || []).map(c => c.field));
      set.add('actions');
      this.tableSelectedColumn = this.columnDefsCopy.filter(c => !!c.field && set.has(c.field as string));
    }
  }

  private applyColumnDefsToGrid(): void {
    if (!this.gridApi) return;
    this.ensureActionsAlwaysSelected();
    this.gridApi.setColumnDefs(this.tableSelectedColumn);
    this.gridApi.setDefaultColDef(this.defaultColDef);
    this.gridApi.refreshHeader();
  }

  isColumnSelected(column: ColDef): boolean {
    if (column.field === 'actions') return true;
    return this.tableSelectedColumn?.some(c => c.field === column.field);
  }

  onColumnCheckboxChange(column: ColDef, event: any): void {
    if (!column?.field) return;

    if (column.field === 'actions') {
      event.target.checked = true;
      return;
    }

    const checked = !!event.target.checked;

    const selectedSet = new Set((this.tableSelectedColumn || []).map(c => c.field).filter(Boolean) as string[]);
    if (checked) selectedSet.add(column.field);
    else selectedSet.delete(column.field);

    selectedSet.add('actions');

    this.tableSelectedColumn = this.columnDefsCopy.filter(c => !!c.field && selectedSet.has(c.field));
    this.applyColumnDefsToGrid();
    this.persistColumnSelection();
  }

  selectAllColumns(): void {
    this.tableSelectedColumn = [...this.columnDefsCopy];
    this.ensureActionsAlwaysSelected();
    this.applyColumnDefsToGrid();
    this.persistColumnSelection();
  }

  clearAllColumns(): void {
    const actionsCol = this.columnDefsCopy.find(c => c.field === 'actions');
    this.tableSelectedColumn = actionsCol ? [actionsCol] : [];
    this.ensureActionsAlwaysSelected();
    this.applyColumnDefsToGrid();
    this.persistColumnSelection();
  }

  // ---------------------------------------
  // Existing logic
  // ---------------------------------------
  async ngOnInit(): Promise<void> {
    this.innerWidth = window.innerWidth;
    this.setPageSize();

    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);

    if (this.permissions == null || this.permissions === '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      });
      await this.router.navigateByUrl('/');
      return;
    }

    this.modalConfigBlocked = {
      modalTitle: "Customer Status",
      modalSize: 'lg',
      hideDismissButton(): boolean { return true; },
      hideCloseButton(): boolean { return true; }
    };

    this.modalConfigReport = {
      modalTitle: "Customer Screening Report",
      modalSize: 'xl',
      css: "min-height: 500px!important",
      hideDismissButton(): boolean { return true; },
      hideCloseButton(): boolean { return true; }
    };

    this.modalConfigAdd = {
      modalTitle: "Add Merchant",
      modalSize: 'xl',
      hideCloseButton(): boolean { return true; },
      hideDismissButton(): boolean { return true; }
    };

    this.modalConfigEdit = {
      modalTitle: "Edit Merchant",
      modalSize: 'xl',
      hideCloseButton(): boolean { return true; },
      hideDismissButton(): boolean { return true; }
    };

    this.modalConfigMerchant = {
      modalTitle: "Merchant RMS Configuration",
      modalSize: 'xl',
      hideCloseButton(): boolean { return true; },
      hideDismissButton(): boolean { return true; }
    };

    // ✅ Load user -> set key -> load selection
    this.userService.getUserProfileNew().subscribe((data: any) => {
      this.profileEmailForKey = (data?.EMAILID || data?.emailId || data?.EMAIL || '').toString();
      this.storageReady = true;

      const loaded = this.loadColumnSelectionFromStorage();
      if (!loaded) {
        // first time -> save default "all selected"
        this.persistColumnSelection();
      }

      this.applyColumnDefsToGrid();
    });
  }

  downloadPdf(data: any, info: any) {
    if (data) {
      const linkSource = data;
      const downloadLink = document.createElement('a');
      const fileName = info + '_Screening_Report.pdf';
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      this.loading = false;
    } else {
      this.mindatadis = false;
      this.loading = false;
    }
  }

  setPageSize() {
    if (this.innerWidth <= 1600 && this.innerWidth >= 1200) {
      this.maxSize = 5;
    } else if (this.innerWidth <= 1199 && this.innerWidth >= 768) {
      this.maxSize = 3;
      this.ellipses = false;
    } else if (this.innerWidth < 768) {
      this.maxSize = 2;
      this.ellipses = false;
    }
  }

  // ✅ Export excludes: actions, screen, unmasking
  onExportCSV() {
    const today = new Date();
    const referenceId =
      today.getFullYear().toString() + "-" +
      ("0" + (today.getMonth() + 1)).slice(-2) + "-" +
      ("0" + today.getDate()).slice(-2) + "_" +
      ("0" + today.getHours()).slice(-2) + "-" +
      ("0" + today.getMinutes()).slice(-2) + "-" +
      ("0" + today.getSeconds()).slice(-2);

    const fileName = 'Customer_List' + "_" + referenceId;

    return this.customerService.getCustomerActiveList(
      this.fullName, this.mobileNumber, this.status, this.kycStatus, this.emailId,
      "", "", this.pageSize, this.pageNumber, this.walletId, this.documentId
    ).subscribe((data: any) => {

      const expData: any[] = [];
      if (!data || !data.content || data.content.length === 0) {
        this.alertService.errorAlertWithMessage("No records present");
        return;
      }

      (data.content).forEach((curr: any) => {
        const tempRec: any = {};
        this.tableSelectedColumn.forEach((col) => {
          const field = col?.field as string;
          if (!field) return;

          if (EXCLUDED_EXPORT_FIELDS.has(field)) return; // ✅ exclude UI-only columns
          tempRec[field] = curr[field];
        });
        expData.push(tempRec);
      });

      this.exportAsExcelFile(expData, fileName);
    });
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const exportCols = (this.tableSelectedColumn || [])
      .filter(c => !!c.field && !EXCLUDED_EXPORT_FIELDS.has(c.field as string));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([], {
      // @ts-ignore
      header: [...exportCols.map((c: any) => c.headerName || c.field)]
    });

    const wb = XLSX.utils.book_new();
    XLSX.utils.sheet_add_aoa(worksheet, [[...exportCols.map((c: any) => c.headerName || c.field)]]);
    XLSX.utils.sheet_add_json(worksheet, json, { origin: 'A2', skipHeader: true });
    XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');

    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + new Date().getTime() + EXCEL_EXTENSION);
  }

  resetFilter() {
    this.searchFromDate = { year: 0, month: 0, day: 0 };
    this.searchToDate = { year: 0, month: 0, day: 0 };
    this.fullName = "";
    this.mobileNumber = "";
    this.emailId = "";
    this.walletId = "";
    this.documentId = "";
    this.filStatus?.handleClearClick?.();
    this.filResellerPartnerId?.handleClearClick?.();
  }

  onSearchBtnClick($event: Event) {
    this.currentPage = 1;
    this.pageNumber = 0;

    return this.customerService.getCustomerActiveList(
      this.fullName, this.mobileNumber, this.status, this.kycStatus, this.emailId,
      "", "", this.pageSize, this.pageNumber, this.walletId, this.documentId
    ).subscribe((data: any) => {

      this.rowData = data.content;
      this.collectiondata = data.content;
      this.collectionSize = data.totalElements;

      if (!this.rowData || this.rowData.length <= 0) {
        this.alertService.errorAlertWithMessage("No records present");
        return;
      }
    });
  }

  async onRowDoubleClicked(param: RowClickedEvent | any) {
    return await this.router.navigate(['/customerEdit'], {
      queryParams: {
        mid: param?.data?.mobileNumber,
        date: param?.data?.createdDate,
        userId: param?.data?.userId || param?.data?.mobileNumber
      }
    });
  }

  onRowClicked(param: RowClickedEvent | any) { }

  onPaginationChange(param: PaginationChangedEvent | any) {
    this.gridApi.applyTransaction({ remove: this.rowData });
    this.gridApi.showLoadingOverlay();

    this.pageNumber = (param - 1);

    return this.customerService.getCustomerActiveList(
      this.fullName, this.mobileNumber, this.status, this.kycStatus, this.emailId,
      "", "", this.pageSize, this.pageNumber, this.walletId, this.documentId
    ).subscribe((data: any) => (
      this.rowData = data.content,
      this.collectiondata = data.content,
      this.collectionSize = data.totalElements,
      this.gridApi.applyTransaction({ add: this.rowData })
    ));
  }

  onPageSizeChanges($event: Event) {
    this.gridApi.paginationSetPageSize(this.pageSize);
    this.gridApi.applyTransaction({ remove: this.rowData });
    this.gridApi.showLoadingOverlay();

    return this.customerService.getCustomerActiveList(
      this.fullName, this.mobileNumber, this.status, this.kycStatus, this.emailId,
      "", "", this.pageSize, this.pageNumber, this.walletId, this.documentId
    ).subscribe((data: any) => (
      this.rowData = data.content,
      this.collectiondata = data.content,
      this.collectionSize = data.totalElements,
      this.gridApi.applyTransaction({ add: this.rowData })
    ));
  }

  onGridReady(params: GridReadyEvent<IMerchantData>) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    // Apply selection as soon as grid is ready
    this.applyColumnDefsToGrid();

    this.userService.getUserProfileNew().subscribe((data: any) => {
      if (data.ROLEID == 273) {
        this.gridColumnApi.setColumnsVisible(["screen"], false);
      }
    });

    if (!this.permissions.includes('Edit')) {
      this.gridColumnApi.setColumnsVisible(["actions"], false);
    }

    this.gridApi.showLoadingOverlay();
    this.gridApi.setQuickFilter(this.globalSearch);

    const allColumnIds: (string | Column)[] = [];
    params?.columnApi?.getColumns()?.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    params?.columnApi?.autoSizeColumns(allColumnIds, false);

    return this.customerService.getCustomerActiveList(
      this.fullName, this.mobileNumber, this.status, this.kycStatus, this.emailId,
      "", "", this.pageSize, this.pageNumber, this.walletId, this.documentId
    ).subscribe((data: any) => {
      this.rowData = data.content;
      this.collectiondata = data.content;
      this.collectionSize = data.totalElements;
    });
  }

  quickFilterShowAction($event: Event) {
    this.quickFilterShow = !this.quickFilterShow;
    if (!this.quickFilterShow) {
      this.filSearchMerName?.handleClearClick?.();
      this.filSearchMID?.handleClearClick?.();
      this.filResellerPartnerId?.handleClearClick?.();
      this.filStatus?.handleClearClick?.();
      this.searchFromDate = this.ngbCalender.getToday();
      this.searchToDate = this.ngbCalender.getToday();
      this.refreshGrid();
    }
  }

  onFilterChange(param: FilterChangedEvent | any) { }

  onFilterModified(param: FilterModifiedEvent | any) {
    const temp = param?.filterInstance;
    this.filterObj[param?.column?.colId] = temp;
  }

  onFilterOpened(param: FilterOpenedEvent | any) { }

  onSortChange(event: any) { }

  fun(id: any) {
    document?.getElementById(id)?.classList.add("hey");
  }

  funover(id: any) {
    document?.getElementById(id)?.classList.remove("hey");
  }

  refreshGrid() {
    this.gridApi.applyTransaction({ remove: this.rowData });

    return this.customerService.getCustomerActiveList(
      this.fullName, this.mobileNumber, this.status, this.kycStatus, this.emailId,
      "", "", this.pageSize, this.pageNumber, this.walletId, this.documentId
    ).subscribe((data: any) => (
      this.rowData = data.content,
      this.collectiondata = data.content,
      this.collectionSize = data.totalElements
    ));
  }

  closeModalBlocked($event: any) {
    if (!$event.showModal) {
      this.modalblockedComponent.close();
      this.refreshGrid();
    }
  }
}
